module.exports = __webpack_public_path__ + "img/wave.2b83d869.png";